// Import dependencies
import React from 'react';
import axios from 'axios';
import cookie from 'js-cookie';
import { tokenize } from '../../../../helper';
import './AffiliateAdministrationPage.css';

// Import styling
import { FaPlus, FaPen } from 'react-icons/fa';
import AdminNavbar from '../../../reusables/adminNavbar';

// Import config
import config from '../../../../configs/config.json';
const API_URL = config.API_URL;
const ADMIN_API_URL = API_URL + '/admin';

class AffiliateAdministrationPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            affiliates: [],
            displayAddMenu: false,
            selectedIndex: 0,
            updatedPortfolio: '',
            newAffiliate: {
                number: '',
                portfolio: ''
            },
            maxAffiliate: 0,
            sortKey: 'AFFILIATEASC'
        }
    }

    componentDidMount() {
        // As the component mounts, check if a token is already stored in the cookie
        var token = cookie.get('token');
        var user_type = cookie.get('user-type');
        if (token) {
            if (user_type === 'admin') {
                // Authorized as admin
                this.fetchAffiliates();
            } else {
                // Not authorized as admin, re-direct to log in page
                window.location.href = '/admin/';
            }
        } else {
            // No token found, re-direct to log in page
            window.location.href = '/admin/'
        }
    }

    fetchAffiliates = () => {
        axios.get(`${ADMIN_API_URL}/affiliates?sort=${this.state.sortKey}`, tokenize())
            .then(response => {
                console.log(response.data);
                var maxAffiliate = 0;
                response.data.affiliates.forEach(affiliate => {
                    if (affiliate.affiliate_number > maxAffiliate) {
                        maxAffiliate = affiliate.affiliate_number;
                    }
                })
                var newAffiliate = { number: maxAffiliate + 1, portfolio: '' };
                this.setState({ affiliates: response.data.affiliates, stats: response.data.affiliates, maxAffiliate, newAffiliate });
            })
            .catch(error => {
                console.log('Failed to retrieve affiliates');
                console.log(error);
            })
    }

    handleSortRequest = (type) => {
        switch (type) {
            case 'affiliate':
                (this.state.sortKey === 'AFFILIATEASC') ? this.setState({ sortKey: 'AFFILIATEDESC' }) : this.setState({ sortKey: 'AFFILIATEASC' });
                break;
            case 'portfolio':
                (this.state.sortKey === 'PORTFOLIOASC') ? this.setState({ sortKey: 'PORTFOLIODESC' }) : this.setState({ sortKey: 'PORTFOLIOASC' });
                break;
            default:
                this.setState({ sortKey: 'AFFILIATEASC' });
        }

        setTimeout(() => {
            this.fetchAffiliates();
        }, 100)
    }

    editAffiliate = (index) => {
        // Select an affiliate from the list when the edit button is clicked.
        this.setState({ selectedIndex: index, updatedPortfolio: this.state.affiliates[index].vimeo_portfolio });
    }

    updateAffiliateField = (event) => {
        // Update the portfolio number when typing is detected within modal
        this.setState({ updatedPortfolio: event.target.value })
    }

    submitAffiliateUpdate = () => {
        // Submit request to update affiliate to back-end
        axios.patch(`${ADMIN_API_URL}/affiliates`, tokenize({ ID: this.state.affiliates[this.state.selectedIndex].ID, portfolio: this.state.updatedPortfolio }))
            .then(response => {
                // console.log("Successfully updated");

                // wait 1 second for back-end latency
                setTimeout(function () {

                    this.fetchAffiliates();
                }, 1000);

            })
            .catch(error => {
                console.log('Failed to update affiliate');
                console.log(error);
            })
    }

    addNewAffiliate = (fieldType) => (event) => {
        var newAffiliate = this.state.newAffiliate;
        if (fieldType === 'number') {
            // The affiliate number should only be a two digit code
            if (event.target.value.length < 3 && event.target.value > -1) {
                newAffiliate[fieldType] = event.target.value;
                this.setState({ newAffiliate });
            }
        } else {
            newAffiliate['portfolio'] = event.target.value;
            this.setState({ newAffiliate });
        }
    }

    submitNewAffiliate = () => {
        var newAffiliate = this.state.newAffiliate;
        var found = false;
        this.state.affiliates.forEach(affiliate => {
            if (affiliate.affiliate_number === newAffiliate.number) {
                found = true;
            }
        })
        if (!found) {
            var { number, portfolio } = this.state.newAffiliate;
            axios.post(`${ADMIN_API_URL}/affiliates`, tokenize({ number, portfolio }))
                .then(response => {
                    this.fetchAffiliates();
                })
                .catch(error => {
                    console.log(error);
                })
        } else {
            alert("That affiliate already exists!");
        }
    }

    render() {
        return (
            <div>
                <AdminNavbar />
                <h1 className='pageTitle'>Affiliate Management</h1>

                <table className='table-striped generalTable'>
                    <thead>
                        <tr>
                            <td onClick={() => this.handleSortRequest('affiliate')}>Affiliate Number</td>
                            <td onClick={() => this.handleSortRequest('portfolio')}>Vimeo Portfolio Number</td>
                            <td><button type='button' title='Add New Affiliate' className='btn btn-success' data-toggle="modal" data-target="#addAffiliateModal"><FaPlus /></button></td>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            this.state.affiliates.map((affiliate, index) => {
                                var affiliateNumber = (affiliate.affiliate_number < 10 && affiliate.affiliate_number !== null) ? '0' + affiliate.affiliate_number : affiliate.affiliate_number
                                affiliateNumber = (affiliateNumber === null || affiliateNumber === '') ? 'Default' : affiliateNumber;

                                return (<tr key={index}>
                                    <td>{affiliateNumber}</td>
                                    <td>{affiliate.vimeo_portfolio}</td>
                                    <td><button type='button' title='Edit Portfolio Number' className='btn btn-warning' data-toggle="modal" data-target="#editAffiliateModal" onClick={() => this.editAffiliate(index)}><FaPen /></button></td>
                                </tr>)
                            })
                        }
                    </tbody>
                </table>



                {/* Add Affiliate Modal */}
                <div className="modal fade" id="addAffiliateModal" tabIndex="-1" role="dialog" aria-labelledby="addAffiliateModalLabel" aria-hidden="true">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="addAffiliateModalLabel">Add Affiliate</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <label htmlFor="formAffiateNumber">Affiliate Number</label>
                                <input id='formAffiateNumber' className='form-control' type='number' placeholder='Affiliate Number' value={this.state.newAffiliate.number} onChange={this.addNewAffiliate('number')} />

                                <label htmlFor="formPortfolioNumber">Vimeo Portfolio Number</label>
                                <input id='formPortfolioNumber' className='form-control' type='number' placeholder='Portfolio Number' value={this.state.newAffiliate.portfolio} onChange={this.addNewAffiliate('portfolio')} />
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Cancel</button>
                                <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={this.submitNewAffiliate}>Save Changes</button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Edit Affiliate Modal */}
                <div className="modal fade" id="editAffiliateModal" tabIndex="-1" role="dialog" aria-labelledby="editAffiliateModalLabel" aria-hidden="true">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="editAffiliateModalLabel">Modify Affiliate {this.state.affiliates.length !== 0 ? ((this.state.affiliates[this.state.selectedIndex].affiliate_number < 10 && this.state.affiliates[this.state.selectedIndex].affiliate_number !== null) ? '0' + this.state.affiliates[this.state.selectedIndex].affiliate_number : this.state.affiliates[this.state.selectedIndex].affiliate_number) : ''}</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <label htmlFor="formPortfolioNumber">Vimeo Portfolio Number</label>
                                <input id='formPortfolioNumber' className='form-control' type='number' placeholder='Portfolio Number' value={this.state.updatedPortfolio} onChange={this.updateAffiliateField} />
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Cancel</button>
                                <button type="button" className="btn btn-warning" data-dismiss="modal" onClick={this.submitAffiliateUpdate} >Save Changes</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default AffiliateAdministrationPage;